import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { NavLink, Link } from 'react-router-dom';
import { withRouter } from 'react-router';

import { logoutUser,
  showPasswordChangeModal,
  hidePasswordChangeModal,
  userPasswordChange,
} from 'actions';

import { AuthMode } from 'actions/auth/common';

import blanks from 'components/Blanks/blanks.json';
import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import PasswordChangeModal from 'components/Modals/PasswordChangeModal';
import withContainerErrorBoundary from 'components/ErrorBoundaries/ContainerErrorBoundary/withContainerErrorBoundary';
import PoweredBy from 'components/PoweredBy';

class Header extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.shape().isRequired,
    username: PropTypes.string.isRequired,
    settings: PropTypes.shape(),
    sessionAuthMode: PropTypes.string,
    permissions: PropTypes.arrayOf(PropTypes.string),
    isPasswordChangeModalShown: PropTypes.bool
  };

  static defaultProps = {
    settings: null,
    permissions: null,
    sessionAuthMode: AuthMode.Manual,
    isPasswordChangeModalShown: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      moduleMenuShown: false
    };
  }

  /* eslint-disable-next-line camelcase */
  UNSAFE_componentWillMount() {
    document.addEventListener('click', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  get changePasswordText() {
    const { sessionAuthMode } = this.props;
    return (sessionAuthMode !== AuthMode.SSO) ? 'Change Password' : null;
  }

  handleClickOutside = (event) => {
    const { moduleMenuShown } = this.state;
    if (moduleMenuShown && (!this.moduleMenu || !this.moduleMenu.contains(event.target))) {
      this.toggleMenu();
    }
  }

  logout() {
    const { dispatch, settings, sessionAuthMode } = this.props;
    const switchClient = sessionAuthMode === AuthMode.SSO && settings && settings.clients && settings.clients.length !== 1;
    dispatch(logoutUser(switchClient, sessionAuthMode === AuthMode.SSO));
    localStorage.setItem('taina.logout', Date.now());
  }

  openPasswordChangeModal() {
    const { dispatch, sessionAuthMode } = this.props;

    if (sessionAuthMode === AuthMode.SSO) {
      // Don't allow user to change password when logged in via SSO
      return;
    }

    dispatch(showPasswordChangeModal());
  }

  closePasswordChangeModal() {
    const { dispatch } = this.props;
    dispatch(hidePasswordChangeModal());
  }

  processPasswordChangeModal(updateData) {
    const { dispatch, username } = this.props;
    dispatch(userPasswordChange(username, updateData));
  }

  toggleMenu() {
    const { moduleMenuShown } = this.state;
    this.setState({ moduleMenuShown: !moduleMenuShown });
  }

  showModuleMenu() {
    const { settings, permissions } = this.props;

    const modulesLicenced = settings && (settings.showBatches || settings.showCic || settings.showDigitalEntry);

    return modulesLicenced && (AccessControl.hasPermission(permissions, [
      ActivityPerms.cicwfInitialReviewer,
      ActivityPerms.cicwfSecondaryReviewer,
      ActivityPerms.cicwfExpertReviewer,
      ActivityPerms.cicwfSupplReviewer,
      ActivityPerms.scannedViewBatches
    ]) || AccessControl.hasPermission(permissions, [
      ActivityPerms.fwfInitialReviewer,
      ActivityPerms.digitalEntryAccessPortal
    ], true));
  }

  renderBlankTitle() {
    const { location: { pathname } } = this.props;
    const path = pathname.split('/');
    if (
      path.length === 4 || (path.length === 5 && path.indexOf('pdf') !== -1)
    ) {
      return blanks[path[2]];
    }
    return null;
  }

  render() {
    const {
      location,
      username,
      settings,
      permissions,
      isPasswordChangeModalShown
    } = this.props;
    const { moduleMenuShown } = this.state;
    const path = location.pathname;

    return (
      <nav className="navbar navbar-fixed">
        <section className="navbar-section">
          <NavLink to="/" exact activeClassName="active" className="btn btn-link btn-home" tabIndex={ 0 }>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M21 13v10h-6v-6h-6v6h-6v-10h-3l12-12 12 12h-3zm-1-5.907v-5.093h-3v2.093l3 3z" /></svg>
          </NavLink>
          { (AccessControl.hasPermission(permissions, [ActivityPerms.scannedValidate, ActivityPerms.electronicValidate]))
            ? <NavLink to="/validation-results" exact activeClassName="active" className="btn btn-link">
              Validation Results
            </NavLink> : null }
          { AccessControl.hasPermission(permissions, [ActivityPerms.miView])
            ? <NavLink to="/mi-dashboard" exact activeClassName="active" className="btn btn-link">
              MI
            </NavLink> : null }
          { this.showModuleMenu() && <div ref={ (node) => { this.moduleMenu = node; } } className="module-menu">
            <button onClick={ () => this.toggleMenu() } className={ `module-menu-link btn btn-link ${ moduleMenuShown ? 'active' : '' }` } type="button">
              Advanced
              <span className="icon icon-caret" />
            </button>
            <ul className={ moduleMenuShown ? 'show' : 'hide' }>
              { settings && settings.showCic && AccessControl.hasPermission(permissions, [ActivityPerms.cicwfInitialReviewer, ActivityPerms.cicwfSecondaryReviewer, ActivityPerms.cicwfExpertReviewer, ActivityPerms.cicwfSupplReviewer])
                ? <li>
                  <NavLink to="/customers/rtks" exact activeClassName="active" className="btn btn-link" onClick={ () => this.toggleMenu() }>
                    RtK / CiC
                  </NavLink>
                </li> : null }
              { settings && settings.showBatches && AccessControl.hasPermission(permissions, [ActivityPerms.scannedViewBatches])
                ? <li>
                  <NavLink to="/batches" exact activeClassName="active" className="btn btn-link" onClick={ () => this.toggleMenu() }>
                    Batches
                  </NavLink>
                </li> : null }
              { settings && settings.showDigitalEntry && AccessControl.hasPermission(permissions, [ActivityPerms.digitalEntryAccessPortal, ActivityPerms.fwfInitialReviewer], true)
                ? <li>
                  <NavLink to="/digital-entry" className="btn btn-link" onClick={ () => this.toggleMenu() }>
                    Digital Entry
                  </NavLink>
                </li> : null }
            </ul>
          </div> }
        </section>
        <section className="logo-container">
          <Link to="/">
            <div className="header-logo" />
          </Link>
          <PoweredBy />
        </section>
        <section className="navbar-section navbar-auth-section">
          { path.indexOf('/forms/') === 0 && <NavLink
            to={ path }
            exact
            activeClassName="active"
            className="btn btn-link"
          >
            { this.renderBlankTitle() } Form
          </NavLink> }
          { path.search(/batch\/\d*\/forms/gm) >= 0 && <NavLink
            to={ path }
            exact
            activeClassName="active"
            className="btn btn-link"
          >
            Batch Forms
          </NavLink> }
          { settings != null && settings.selectedClient != null && settings.selectedClient.value != null && settings.isMultiTenant === true
            && <span className="client-header-value text-ellipsis">Client : { settings.selectedClient.value }</span> }
          <figure className="avatar avatar-sm">
            <span role="button" tabIndex={ 0 } onClick={ () => this.openPasswordChangeModal() } aria-hidden="true"><img src="/assets/images/avatar-large.png" alt={ this.changePasswordText } title={ this.changePasswordText } /></span>
          </figure>
          <div className="auth">
            <span className="username">{ username }</span>
            <button
              type="button"
              className="btn btn-link btn-logout"
              onClick={ () => this.logout() }
            >
              Logout
            </button>
          </div>
        </section>
        <section className="mobile-menu-dropdown dropdown dropdown-right">
          <button type="button" className="btn btn-lg btn-link dropdown-toggle">
            <span className="icon icon-more-vert" />
          </button>
          <ul className="menu">
            <li className="menu-item auth-menu-item">
              <figure className="avatar avatar-sm">
                <img src="/assets/images/avatar-large.png" alt="Avatar" />
              </figure>
              <div className="auth">
                <span className="username">{ username }</span>
                <button
                  type="button"
                  className="btn btn-link btn-logout"
                  onClick={ () => this.logout() }
                >
                  Logout
                </button>
              </div>
            </li>
            <li className="menu-item">
              <NavLink to="/" exact>
                HOME
              </NavLink>
            </li>
            { AccessControl.hasPermission(permissions, [ActivityPerms.scannedValidate, ActivityPerms.electronicValidate]) ? <li className="menu-item">
              <NavLink to="/validation-results">
                Validation Results
              </NavLink>
            </li> : null }
            { AccessControl.hasPermission(permissions, [ActivityPerms.miView]) ? <li className="menu-item">
              <NavLink to="/mi-dashboard">
                MI
              </NavLink>
            </li> : null }
            { settings && settings.showCic && AccessControl.hasPermission(permissions, [ActivityPerms.cicwfInitialReviewer,
              ActivityPerms.cicwfSecondaryReviewer,
              ActivityPerms.cicwfExpertReviewer,
              ActivityPerms.cicwfSupplReviewer]) ? <li className="menu-item">
                <NavLink to="/customers/rtks">
                  RtK / CiC
                </NavLink>
              </li> : null }
            { settings && settings.showBatches && AccessControl.hasPermission(permissions, [ActivityPerms.scannedViewBatches]) ? <li className="menu-item">
              <NavLink to="/batches">
                Batches
              </NavLink>
            </li> : null }
            { settings && settings.showDigitalEntry && AccessControl.hasPermission(permissions, [ActivityPerms.digitalEntryAccessPortal, ActivityPerms.fwfInitialReviewer], true) ? <li className="menu-item">
              <NavLink to="/digital-entry">
                Digital Entry
              </NavLink>
            </li> : null }
          </ul>
        </section>
        <PasswordChangeModal
          isShown={ isPasswordChangeModalShown }
          onConfirmUpdate={ updateData => this.processPasswordChangeModal(updateData) }
          onCancel={ () => this.closePasswordChangeModal() }
        />
      </nav>
    );
  }
}

function mapStateToProps(state) {
  const {
    auth: {
      isPasswordChangeModalShown,
      sessionAuthMode
    },
  } = state;

  return {
    isPasswordChangeModalShown,
    sessionAuthMode
  };
}

export default withRouter(connect(
  mapStateToProps
)(withContainerErrorBoundary(Header, 'Header')));
